import { IAppState } from '../../../AppModulesWrapper';

export function selectTermsDurationInDays(state: IAppState): number {
  return state.servicePickerWidget.termsDurations.durationInDays;
}
